export enum InventoryItemActionStatus {
  Applied = "applied",
  Skipped = "skipped",
}
